import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-bg relative z-10 flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <div className="mb-8"><Logo size="text-2xl" /></div>
        <div className="surface rounded-xl p-10" data-testid="payment-cancel-panel">
          <XCircle size={56} className="text-muted mx-auto mb-4" />
          <h1 className="font-display text-2xl font-bold mb-2">Paiement annulé</h1>
          <p className="text-muted text-sm mb-6">Vous avez annulé le paiement. Aucun montant n'a été débité.</p>
          <button onClick={() => navigate("/app/billing")} data-testid="back-billing-btn" className="bg-accent text-black font-semibold px-6 py-3 rounded-md hover-lift w-full">Revenir à l'abonnement</button>
        </div>
      </div>
    </div>
  );
}
